import { useCallback } from "react";
import { Particles, ParticlesProvider } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const HeroParticles = () => {
  const init = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
      <ParticlesProvider init={init}>
        <Particles
          id="axiom-hero-particles"
          className="absolute inset-0"
          options={{
            fullScreen: false,
            background: { color: { value: "transparent" } },
            fpsLimit: 60,
            particles: {
              number: { value: 42 },
              color: { value: "#2563EB" },
              opacity: { value: 0.22 },
              size: { value: { min: 1, max: 2.4 } },
              links: {
                enable: true,
                distance: 150,
                color: "#64748B",
                opacity: 0.18,
                width: 1,
              },
              move: { enable: true, speed: 0.55, outModes: { default: "out" } },
            },
            detectRetina: true,
          }}
        />
      </ParticlesProvider>
    </div>
  );
};

export default HeroParticles;
